import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '../utils/translations';

const Temperature = props => {
    const { data, language, tempFormat } = props;

    return (
        <div className="wrapper-data-48h mc-widget-temperature">
            {/* Label */}
            <div className="wrapper-data-48h__labels mc-widget-temperature__labels">
                <div className="mc-widget-temperature__label">
                    <h3>
                        {translate(language, 'municipal48h_temp')} ({tempFormat.replace(' ºC', 'ºC')})
                    </h3>
                </div>
            </div>
            {/* Data */}
            <div className="wrapper-data-48h__data mc-widget-temperature__data">
                {data.map((data, index) => (
                    <span key={index}>
                        {data.valor !== null ? Math.round(data.valor) : ''}
                    </span>
                ))}
            </div>
        </div>
    );
};

Temperature.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            data: PropTypes.string,
            valor: PropTypes.number,
        })
    ),
    language: PropTypes.string,
    tempFormat: PropTypes.string,
};

export default Temperature;



// WEBPACK FOOTER //
// ./src/partials/Temperature.js